// Pure derivation of the Overview tab's headline "stage" from project +
// local UI state. Kept module-level so the Overview tab is a thin switch
// on the result and precedence is unit-testable in one place.
//
// Precedence (highest wins):
//   1. Local upload in flight   → 'uploading'
//   2. Edited video active/done → 'rendering' / 'render_failed' /
//                                 'render_cancelled' / 'edit_complete'
//   3. Source video failure/cancel → 'analysis_failed' / 'analysis_cancelled'
//   4. Source video in progress → 'analyzing'
//   5. Source video ready → 'ready_to_edit'
//   6. Photos uploaded but no video → 'empty_photos'
//   7. Nothing at all → 'empty'
//
// The edited-video branch wins over base analysis states (a completed
// render is still shown even while re-analysis runs) but a local upload
// beats everything: the user just added new footage and expects to see it.
// `empty_photos` only applies when there's no video path at all — once a
// photo set is compiled into a source video, the video-status branches win.
export function deriveOverviewStage(project, { uploading = false, isAnalysisPending = false, hasPhotos = false } = {}) {
  if (uploading) return 'uploading';

  const editedStatus = project?.editedVideo?.status || null;
  if (editedStatus === 'processing' || editedStatus === 'queued') return 'rendering';
  if (editedStatus === 'failed') return 'render_failed';
  if (editedStatus === 'cancelled') return 'render_cancelled';
  if (editedStatus === 'complete') return 'edit_complete';

  const videoStatus = project?.video?.status || null;
  if (videoStatus === 'failed') return 'analysis_failed';
  if (videoStatus === 'cancelled') return 'analysis_cancelled';
  if (isAnalysisPending || videoStatus === 'analyzing' || videoStatus === 'queued') return 'analyzing';
  if (videoStatus === 'analyzed' || videoStatus === 'complete') return 'ready_to_edit';

  if (hasPhotos) return 'empty_photos';
  return 'empty';
}
